import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export type Lang = 'ar' | 'en';
const STORAGE_KEY = 'cig_lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);
  private doc = inject(DOCUMENT);

  private _current: Lang = 'ar';

  get current(): Lang {
    return this._current;
  }

  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY) as Lang | null;
    if (stored === 'ar' || stored === 'en') {
      this._current = stored;
    } else {
      this._current = 'ar';
    }
    this.apply();
  }

  setLang(lang: Lang): void {
    this._current = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    this.translate.use(lang);
    this.applyHtml();
  }

  toggle(): Lang {
    const next: Lang = this._current === 'ar' ? 'en' : 'ar';
    this.setLang(next);
    return next;
  }

  private apply(): void {
    this.translate.use(this._current);
    this.applyHtml();
  }

  private applyHtml(): void {
    const html = this.doc.documentElement;
    html.setAttribute('lang', this._current);
    html.setAttribute('dir', this._current === 'ar' ? 'rtl' : 'ltr');
  }
}
